import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';  // Correct import
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { RiPinDistanceFill, RiFireLine } from "react-icons/ri";

interface ProgressLinearProps {
  achieved: number;
  target: number;
  colour: string;
  heading: string;
  unit?: string;
}

const ProgressLinear: React.FC<ProgressLinearProps> = ({
  achieved,
  target,
  colour,
  heading,
  unit = "Km",
}) => {
  const rawProgress = (achieved / target) * 100;
  const progress = isNaN(rawProgress) || !isFinite(rawProgress) ? 0 : Math.min(rawProgress, 100);
  // Ensure progress doesn't exceed 100%

  return (
    <div className="progress-linear-container">
      <span className="progress-linear-icon" style={{ color: "var(--text-color)" }}>
        <RiPinDistanceFill />
      </span>

      {/* Progress Bar */}
      <div className="progress-linear-bar-wrapper">
        <div
          className="progress-linear-bar-filled"
          style={{
            width: `${progress}%`, // Dynamically set width based on progress
            backgroundColor: colour,
          }}
        ></div>
      </div>

      {/* Footer Text */}
      <div className="progress-linear-footer" style={{ color: "var(--text-color)" }}>
        <span className="progress-linear-heading">{heading}</span>

        {/* RIGHT SIDE WRAPPER: using inline-flex to keep them on the same line */}
        <span style={{ display: "inline-flex", alignItems: "baseline", gap: "0.5rem" }}>
          <span className="progress-linear-value">
            {achieved} {unit}
          </span>
          <span className="covered">
            Covered
          </span>
        </span>
      </div>
    </div>
  );
};
//commited
export default ProgressLinear;
